'use client';

import Backdrop from '@mui/material/Backdrop';
import { FC } from 'react';
import { BarePopover } from 'atoms/BarePopover';
import { PopoverProps } from 'modules/mui/types';
import styles from './Popover.module.css';

export const Popover: FC<PopoverProps> = ({
  children,
  open,
  onClose,
  ...props
}) => {
  const handleClose = () => onClose?.({}, 'backdropClick');

  return (
    <>
      <BarePopover
        open={open}
        hideBackdrop
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...props}
        classes={{
          root: styles.root,
          paper: styles.paper,
        }}
      >
        {children}
      </BarePopover>
      <Backdrop
        classes={{ root: styles.backdrop }}
        open={open}
        onClick={handleClose}
        transitionDuration={
          typeof props.transitionDuration === 'number'
            ? props.transitionDuration
            : 200
        }
      />
    </>
  );
};
